import React, { useRef } from 'react';
import clsx from 'clsx';
import { Collapse } from '@ag1/ui';
import { PlusToMinusIcon, Typography } from '@ag1/ui';
import { StudioBaseIconV2 } from 'shared/studio/StudioBaseIcon/StudioBaseIcon';
import { SanityKeyed, FaqItemV2 } from 'types/studio/studio';
import useAddAccessibility from 'shared/hooks/addAccessibility';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { FaqQuestionProps } from './FaqQuestion.types';
import styles from './FaqQuestion.module.scss';

export const FaqQuestion = ({
  qHeadline,
  qText,
  icon,
  isOpen,
  onToggle
}: SanityKeyed<FaqItemV2> & FaqQuestionProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useAddAccessibility(contentRef, true);

  return (
    <div className={clsx(styles.question, isOpen && styles.active)}>
      <div
        className={styles.headline}
        role="button"
        data-gtm-skip-global
        onClick={onToggle}
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            onToggle();
          }
        }}>
        {icon?.asset && (
          <div className={styles.image_wrap}>
            <StudioBaseIconV2 icon={icon} />
          </div>
        )}
        <Typography
          className={styles.headline_text}
          variant="subtitle"
          size="2"
          component="h4"
          weight="700"
          color="black-new"
          noPadding>
          {qHeadline}
        </Typography>
        <PlusToMinusIcon isOpen={isOpen} className={styles.icon} />
      </div>
      <Collapse isOpened={isOpen} ariaOverride={false}>
        <div ref={contentRef}>
          <Typography
            variant="body"
            size="1"
            component="div"
            noPadding
            className={styles.text}
            color="black-new">
            <CustomPortableText value={qText} />
          </Typography>
        </div>
      </Collapse>
    </div>
  );
};
